import React from "react";
import { Table, TableBody, TableHead, TableRow, styled, TableContainer, TableCell, Checkbox, Skeleton } from "@mui/material";
import { Check } from "@mui/icons-material";
import Tooltip from "../Tooltip";

const StyledTableContainer = styled(TableContainer)(({ DynamicMaxHeight }) => ({
  backgroundColor: "transparent",
  maxHeight: DynamicMaxHeight ? DynamicMaxHeight : "60.5vh",
  // height: "70vh",
  overflowX: "auto",
  position: "relative",
  border: "1px solid #fff",
  scrollbarWidth: "none", // Firefox
  "&::-webkit-scrollbar": {
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "3px",
  },

  "@media (max-width: 768px)": {
    maxWidth: "100%",
    overflowX: "scroll",
  },
}));

const StyledTable = styled(Table)(({}) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
     whiteSpace:"nowrap",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
       whiteSpace:"nowrap",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      // padding: "10px 5px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    // backgroundColor: "#444444",
    height: "50px",
    // position: "sticky",
    // top: 0,
    // zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(TableCell)`
  padding: 15px;
 
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
  border: none !important;
  &.narrow {
    width: 10%;
  }

  &.default {
    width: 18%;
  }
`;

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid #fff;
  & td {
    padding: 5px;
  }
`;

const StyledTableBodyCell = styled(TableCell)`
  padding: 10px;
  text-align: center;

   &.narrow {
    width: 10%; 

  &.default {
    width: 18%;
  }
`;

const CustomUncheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  border: 2px solid white;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomCheckedIcon = styled("span")`
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background-color: #50c878;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  & svg {
    width: 20px;
    height: 20px;
  }
`;

const AccessCheckbox = ({ checked, onChange, disabled }) => (
  <Checkbox
    disabled={disabled}
    disableRipple
    checked={checked}
    onChange={onChange}
    icon={<CustomUncheckedIcon />}
    checkedIcon={
      <CustomCheckedIcon>
        <Check />
      </CustomCheckedIcon>
    }
    sx={{ cursor: "pointer" }}
  />
);

const TableSkeleton = ({ columns, rows = 5 }) => (
  <>
    {Array.from(new Array(rows)).map((_, rowIndex) => (
      <StyledTableRow key={`skeleton-${rowIndex}`}>
        {Array.from(new Array(columns)).map((_, cellIndex) => (
          <StyledTableBodyCell key={`skeleton-cell-${cellIndex}`}>
            <Skeleton variant="text" sx={{ fontSize: "1rem" }} animation="wave" width={"100%"} height={"90%"} />
          </StyledTableBodyCell>
        ))}
      </StyledTableRow>
    ))}
  </>
);

const TableError = () => (
  <>
    <StyledTableRow>
      <StyledTableBodyCell colSpan={3} className="text-center text-red-500">
        Something went wrong while loading reports ❌
      </StyledTableBodyCell>
    </StyledTableRow>
  </>
);

const DynamicTable = ({ sections, loading, error, maxHeight, isFetchingNextPage, loadMoreRef , hasReportEditAccess }) => {
  return (
    <div style={{ marginLeft: "6px", marginRight: "6.5px", backgroundColor: "#000", padding: "10px 0px" }}>
      {sections.map((section, sectionIndex) => (
        <StyledTableContainer DynamicMaxHeight={maxHeight} key={sectionIndex}>
          <StyledTable>
            <React.Fragment key={sectionIndex}>
              {/* Header Row */}
              <TableHead>
                <TableRow>
                  {section.headers.map((header, i) => (
                    <StyledTableHeaderCell key={i} className={header.className} sx={{whiteSpace: "nowrap"}}>
                      <Tooltip title={header.tooltip || ""}>
                        {header.label}
                      </Tooltip>
                    </StyledTableHeaderCell>
                  ))}
                </TableRow>
              </TableHead>

              {/* Body Rows */}
              <TableBody>
                {loading || (section?.rows?.length === 0 && isFetchingNextPage) ? (
                  <TableSkeleton columns={section?.headers?.length} rows={10} />
                ) : error ? (
                  <TableError />
                ) : (
                  section?.rows?.map((row, rowIndex) => (
                    <StyledTableRow key={rowIndex}>
                      {row.map((cell, colIndex) => {
                        const cellValue = typeof cell === "object" && cell.value !== undefined ? cell.value : cell;
                        const backgroundColor = cell?.props?.style?.backgroundColor || "transparent";
                        const color = cell?.props?.style?.color || "#fff";
                        const fontWeight = cell?.props?.style?.fontWeight || 400;
                        const fontFamily = cell?.props?.style?.fontFamily || "Poppins";

                        return (
                          <StyledTableBodyCell
                            key={colIndex}
                            className={section?.headers[colIndex]?.className}
                            style={{
                              backgroundColor,
                              color,
                              fontWeight,
                              fontFamily,
                              //whiteSpace:"nowrap",
                              
                            }}
                          >
                            {typeof cellValue === "object" && cellValue.type === "checkbox" ? (
                              <AccessCheckbox disabled={cellValue?.hide} checked={cellValue.checked}  onChange={hasReportEditAccess ? cellValue.onChange : undefined} />
                            ) : (
                              cellValue ? cellValue : "-"
                            )}
                          </StyledTableBodyCell>
                        );
                      })}
                    </StyledTableRow>
                  ))
                )}
                <div
                  ref={loadMoreRef}
                  style={{
                    height: "1px",
                    width: "100%",
                    opacity: 0,
                  }}
                />

                {isFetchingNextPage && section?.rows?.length > 0 && <TableSkeleton columns={section?.headers?.length} rows={5} />}
              </TableBody>
            </React.Fragment>
          </StyledTable>
        </StyledTableContainer>
      ))}
    </div>
  );
};

export default DynamicTable;
